<!-- TODO MOVE to stylesheet -->
<style lang="less">
.icon-sortable {
    color: #888;
}
body.no-footer {
    & {
        padding-bottom: 0;
    }
    #public-footer-wrapper {
        display: none;
    }
    .body-content {
        padding: 0;
    }
}
body.content-scroll {
    .admin-page-body {
        padding-bottom: 0;
    }

    .body-content {
        overflow-y: hidden;
    }
}
.custom-vSelect {
    // avoid white space issue with v-select
    &.v-select:not(.vs--open) .vs__selected + .vs__search {
        height: 0;
        margin: 0;
    }
    .vs__dropdown-toggle,
    &.vs__dropdown-menu {
        border: 1px solid #ced4da;
        border-radius: 0.2rem;
    }
    &.vs__dropdown-menu {
        min-width: max-content !important;
        &[data-popper-placement="top-start"] {
            border-radius: 4px 4px 0 0;
            border-top-style: solid;
            box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
        }
    }
}
</style>
<style scoped lang="less">
@import "/lib/Colors.less";
.v-select {
    background: #fff;
    font-size: 0.875rem;
}
.tile {
    padding-top: 0;
    padding-bottom: 0;
}
.badge {
    font-size: 1em;
    font-weight: 500;
    margin: 10px 0;
}
.vue-data-table {
    & ::v-deep(td) {
        vertical-align: middle;
        padding: 0;
    }
}
.pagination-container,
.result-count {
    position: relative;
    z-index: 1;
}
.datepicker {
    .input-group {
        padding: 0;
    }
    ::v-deep(.form-control.input) {
        padding: 0.5em;
        font-size: 0.875rem;
    }
}
[class^="icon-"]:before,
[class*=" icon-"]:before {
    color: inherit;
}
::v-deep {
    // avoid white space issue with v-select
    .v-select:not(.vs--open) .vs__selected + .vs__search {
        height: 0;
        margin: 0;
    }
    .vs__dropdown-toggle,
    .vs__dropdown-menu {
        border: 1px solid #ced4da;
        border-radius: 0.2rem;
    }
    .vs__dropdown-menu {
        width: auto;
        position: fixed; /* to overflow the side bar */
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        z-index: 1002; // To avoid being overlapped by modal
    }
}

.alert-issues {
    background: @warning;
    color: #000;
    font-weight: 600;
}
</style>
<template>
    <form method="post" :action="searchUrl" class="container-fluid tile" role="form" aria-labelledby="SubmissionsHeading">
        <LoadingPlaceholder v-if="!loaded" />
        <template v-if="loaded">
            <input type="hidden" id="RequestVerificationToken" name="__RequestVerificationToken" :value="xsrfToken" />
            <div class="row flex-nowrap">
                <div id="AdminSearchForm" class="submissions-left-col left-nav-sec" role="complementary" aria-label="Search Criteria">
                    <h1 class="admin-content-heading" id="SubmissionsHeading">Submissions</h1>
                    <div class="mb-2" v-if="showTestMode && availableTestModes.length > 1">
                        <label class="control-label">
                            Test Submissions
                            <span class="switch">
                                <input type="checkbox" v-model="testMode" name="TestMode" />
                                <span class="slider"></span>
                            </span>
                        </label>
                    </div>
                    <div v-else-if="testMode" class="alert alert-test py-1 px-2">Searching Test Submissions</div>
                    <div class="form-group">
                        <span class="control-label">Form</span>
                        <v-select ref="dropdownRef" class="w-100 custom-vSelect" v-model="formNameVersion" name="FormNameVersion" :options="formNameOptions" @open="openDropdown(dropdownRef, 'Form')" :dropdown-should-open="dropdownShouldOpen" append-to-body :calculate-position="calculatePositionWithPopper" label="label" placeholder="Select a form..." :clearable="false">
                            <!--
                            class="form-control form-control-sm col-12"
                            <option value="" :value="null">Select a form...</option>
                            <option v-for="option in formNameOptions" :value="option.value">{{ option.label }}</option>
                            -->
                        </v-select>
                        <!--
                        @Html.ValidationMessageFor(i => i.FormNameVersion)
                        -->
                    </div>
                    <p v-if="formNameVersion == null" style="padding: 30px 7px; width: 100%; text-align: center; color: #777777">
                        <span class="text-muted">Select a form.</span>
                    </p>
                    <template v-else>
                        <!--
                        <fieldset class="form-row text-center">
                            <legend class="col-sm-12 m-0">Started</legend>
                            <div class="col-sm-6">
                                <div class="form-group datepicker">
                                    <span class="control-label" id="StartedStartDateLabel">On or After</span>
                                    <DatePicker :config="dateTimePickerConfig" v-model="startedStartDate" :id="'startedStartDateDP'" :placeholder="'mm-dd-yyyy'" :aria-required="false" :ariaLabelledBy="'StartedStartDateLabel'" :class="['form-control-sm']"> </DatePicker>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group datepicker">
                                    <span class="control-label" id="StartedEndDateLabel">Before or On</span>
                                    <DatePicker :config="dateTimePickerConfig" v-model="startedEndDate" :id="'startedEndDateDP'" :placeholder="'mm-dd-yyyy'" :aria-required="false" :ariaLabelledBy="'StartedEndDateLabel'" :class="['form-control-sm']"> </DatePicker>
                                    @Html.ValidationMessageFor(i => i.StartedEndDate)
                                </div>
                            </div>
                        </fieldset>
                        -->
                        <fieldset class="form-row text-center">
                            <legend class="col-sm-12 m-0">Initially Submitted</legend>
                            <div class="col-sm-6">
                                <div class="form-group datepicker">
                                    <span class="control-label" id="SubmittedStartDateLabel">On or After</span>
                                    <DatePicker :config="dateTimePickerConfig" v-model="submittedStartDate" :id="'submittedStartDateDP'" :placeholder="'mm-dd-yyyy'" :aria-required="false" :ariaLabelledBy="'SubmittedStartDateLabel'" :class="['form-control-sm']"> </DatePicker>
                                    <!--
                                    @Html.ValidationMessageFor(i => i.SubmittedStartDate)
                                    -->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group datepicker">
                                    <span class="control-label" id="SubmittedEndDateLabel">Before or On</span>
                                    <DatePicker :config="dateTimePickerConfig" v-model="submittedEndDate" :id="'submittedEndDateDP'" :placeholder="'mm-dd-yyyy'" :aria-required="false" :ariaLabelledBy="'SubmittedEndDateLabel'" :class="['form-control-sm']"> </DatePicker>
                                    <!--
                                    @Html.ValidationMessageFor(i => i.SubmittedEndDate)
                                    -->
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="form-row text-center">
                            <legend class="col-sm-12 m-0">Last Updated</legend>
                            <div class="col-sm-6">
                                <div class="form-group datepicker">
                                    <span class="control-label" id="LastUpdatedStartDateLabel">On or After</span>
                                    <DatePicker :config="dateTimePickerConfig" v-model="lastUpdatedStartDate" :id="'lastUpdatedStartDateDP'" :placeholder="'mm-dd-yyyy'" :aria-required="false" :ariaLabelledBy="'LastUpdatedStartDateLabel'" :class="['form-control-sm']"> </DatePicker>
                                    <!--
                                    @Html.ValidationMessageFor(i => i.LastUpdatedStartDate)
                                    -->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group datepicker">
                                    <span class="control-label" id="LastUpdatedEndDateLabel">Before or On</span>
                                    <DatePicker :config="dateTimePickerConfig" v-model="lastUpdatedEndDate" :id="'lastUpdatedEndDateDP'" :placeholder="'mm-dd-yyyy'" :aria-required="false" :ariaLabelledBy="'LastUpdatedEndDateLabel'" :class="['form-control-sm']"> </DatePicker>
                                    <!--
                                    @Html.ValidationMessageFor(i => i.LastUpdatedEndDate)
                                    -->
                                </div>
                            </div>
                        </fieldset>
                        <div class="form-group" v-for="(searchField, searchIndex) in visibleSearchFields">
                            <input type="hidden" :name="'SearchValue[' + searchIndex + '].Key'" :value="searchField.value" />
                            <label :for="'SearchableField' + searchIndex">{{ searchField.label }}</label>
                            <v-select ref="searchValueDropdownRef" :id="'SearchableField' + searchIndex" :name="'SearchValue[' + searchIndex + '].Value'" v-model="searchFields[searchField.value]" class="custom-vSelect" taggable selectOnTab multiple :options="searchFieldsOptions[searchField.value as unknown as string]" :filterable="false" @search="(search: string, loading: any) => fetchSearchFieldCompletion(searchField.value, search, loading)" @open="openDropdown(searchValueDropdownRef[searchIndex], searchField.label as string)" :dropdown-should-open="dropdownShouldOpen" append-to-body :calculate-position="calculatePositionWithPopper" placeholder="" :clearable="true"> </v-select>
                        </div>
                        <fieldset class="form-group">
                            <legend class="legend-label">Statuses <button type="button" @click.prevent="toggleAllStatuses" class="btn btn-link btn-xs pl-0">Toggle all</button></legend>
                            <div class="form-check" v-for="status in distinctStatusesByLabel">
                                <label class="form-check-label">
                                    <input :indeterminate="checkedStatus.length == 0 && status.isEnabledByDefault" type="checkbox" class="form-check-input" :id="'statusCheck_' + status.values" :checked="checkedStatus.some(i => arrayEquals(i, status.values))" :modelValue="checkedStatus" @change="updateSelectedValues($event, status.values)" name="SearchStatuses" />
                                    <span>{{ status.label }}</span>
                                </label>
                            </div>
                        </fieldset>
                        <div class="alert alert-warning" id="submitFilterWarning" v-if="showSubmitFilterWarning">Unsubmitted submissions will be filtered out if there is an Initially Submitted filter.</div>
                        <div class="form-submit-buttons mt-4 mb-3">
                            <input type="submit" class="btn btn-primary btn-sm" @click.prevent="startSearch" name="Action" value="Search" />
                            <div class="dropdown btn-group btn-group-sm ml-2" v-if="canExport">
                                <button type="button" data-toggle="dropdown" data-trigger="hover" class="btn btn-outline-secondary btn-sm dropdown-toggle" @click.prevent.stop="toggleDropdown($event)" aria-expanded="false">Export</button>
                                <ul class="dropdown-menu">
                                    <li class="nav-item" v-for="(value, key) of exportSchemas">
                                        <input type="submit" class="btn btn-bare" @click.prevent="startExport(value.type, value.schema)" name="Action" :value="key" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-for="exportMetadata in exportMetadatas">
                            <div class="alert" style="padding: 5px" :class="[exportMetadata.status == 'fail' ? 'alert-danger' : exportMetadata.status == 'in-progress' ? 'alert-info' : exportMetadata.status == 'ok' ? 'alert-success' : '']">
                                <div class="row">
                                    <div class="offset-2 col-8">
                                        <div style="display: block; text-align: center">
                                            <strong>Export {{ exportMetadata.status == "fail" ? "failed!" : exportMetadata.status == "in-progress" ? "running..." : exportMetadata.status == "ok" ? "success!" : "" }}</strong>
                                            <LoadingWheel :width="16" v-if="exportMetadata.status == 'in-progress'" style="display: inline-block" />
                                            <p v-if="showSearchEmailExport">You will receive an email with a download link once the export completes.</p>
                                        </div>
                                    </div>
                                    <a tabindex="0" class="col-2 close" style="font-size: 20px" @click.prevent="removeExport(exportMetadata)">&times;</a>
                                    <div v-show="exportMetadata.status == 'fail'" style="padding: 7px 0" class="col-12">
                                        <ul style="margin: 0">
                                            <li v-for="item in exportMetadata.errors">{{ item }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div v-if="$root.hasPageworkflowFeature">
                            <button type="button" @click.prevent="gotoSubmission($event, null)">New</button>
                        </div> -->
                    </template>
                </div>
                <div id="AdminSearchResults" class="submissions-right-col admin-content" role="main" aria-label="Search Results">
                    <div class="d-block d-md-none"><br /><br /></div>
                    <template v-if="searchMetadata.status == null">
                        <p class="admin-content-placeholder">Run a search.</p>
                    </template>
                    <LoadingPlaceholder v-if="searchMetadata.status == 'in-progress'" />
                    <template v-if="searchMetadata.status == 'fail'">
                        <div class="alert alert-warning" style="padding: 10px">
                            <strong>Search failed</strong>
                            <ul>
                                <li v-for="item in searchMetadata.errors">{{ item }}</li>
                            </ul>
                        </div>
                    </template>
                    <template v-if="searchMetadata.status == 'ok'">
                        <div class="d-inline-flex" v-if="searchMetadata.testMode">
                            <div class="alert alert-test w-auto py-1 px-2 d-inline-block" role="alert">Displaying test submissions only</div>
                        </div>
                        <div class="d-block-flex float-right pagination-container">
                            <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="!canRetreatPage" @click.prevent="retreatPage"><span aria-hidden="true">&lt;</span> Prev</button>
                            <template v-if="pageCount == null">
                                <label for="page1" class="mx-2">Page</label>
                                <input class="form-control form-control-sm w-auto d-inline" type="number" min="1" id="page1" v-model="pageDisplay" @change="changePage" />
                            </template>
                            <template v-else>
                                <label for="page1" class="mx-2">Page</label>
                                <select class="form-control form-control-sm w-auto d-inline" id="page1" v-model="tableServerOptions.page" @change="changePage">
                                    <option :selected="tableServerOptions.page == p" :value="p" v-for="p of pageOptions">{{ p + 1 }}</option>
                                </select>
                                <span class="mx-2">of {{ pageCount }}</span>
                            </template>
                            <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="!canAdvancePage" @click.prevent="advancePage">Next <span aria-hidden="true">&gt;</span></button>
                        </div>
                        <div class="d-inline-flex float-right mr-3 py-1 result-count">
                            <span class="badge badge-light mt-0 mb-1"> {{ searchMetadata.unpagedResultCount }}{{ searchMetadata.unpagedResultCount == searchMetadata.maxResultCount ? "+" : "" }} submission{{ searchMetadata.unpagedResultCount != 1 ? "s" : "" }} found </span>
                        </div>
                        <div class="submissions-table-wrapper pull-left">
                            <VueDataTable v-model:server-options="tableServerOptions" :headers="activeColumns" :items="searchMetadata.pagedResults" :loading="tableLoading" table-class-name="vue-data-table table-sm mb-1" :rows-per-page="searchMetadata.pageSize" theme-color="#3f51b5" must-sort hide-footer :prevent-context-menu-row="false">
                                <template #header-submissionUrl>
                                    <span class="sr-only">View Submission</span>
                                </template>
                                <template #header-issues>
                                    <span class="sr-only">Issues</span>
                                </template>

                                <!-- Rows -->
                                <!-- eslint-disable-next-line vue/no-unused-vars -->
                                <template #body="{ key, ...items }">
                                    <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                                    <tr :class="{ 'bg-warning': form.hasIssues }" v-for="form in asForm(Object.values(items))" :key="form.formId">
                                        <td>
                                            <span v-if="form.hasIssues" class="icon p-0 m-0 pl-1 pr-2 icon-warning"></span>
                                        </td>
                                        <td v-for="col in searchMetadata.displayColumns">
                                            {{ getColumnValue(col, form) }}
                                        </td>
                                        <td class="submissions-actions-td row-actions-td nowrap">
                                            <Promised :pending-delay="null" :promise="formUrlsPromise(form)">
                                                <template v-slot="urlPair">
                                                    <div class="btn-group btn-group-sm row-actions">
                                                        <template v-if="canExport">
                                                            <div class="dropdown btn-group btn-group-sm" v-if="Object.keys(urlPair.documents).length > 1 || urlPair.allDocuments || urlPair.attachments">
                                                                <button :id="'pdf-download-' + form.formId" type="button" class="btn btn-bare passthrough dropdown-toggle icon icon-download" aria-haspopup="true" aria-expanded="false" @click.prevent.stop="toggleDropdown($event)" aria-label="Download" />
                                                                <ul class="dropdown-menu dropdown-menu-right" :aria-labeled="'pdf-download-' + form.formId">
                                                                    <template v-for="(url, type) in urlPair.documents">
                                                                        <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                                                                        <li class="nav-item">
                                                                            <a :href="url" class="btn btn-bare icon icon-download" target="_blank">
                                                                                {{ type }}
                                                                            </a>
                                                                        </li>
                                                                    </template>
                                                                    <li class="nav-item" v-if="urlPair.attachments">
                                                                        <a :href="urlPair.attachments" class="btn btn-bare icon icon-download" target="_blank">&nbsp;Attached File(s)</a>
                                                                    </li>
                                                                    <li class="nav-item" v-if="urlPair.allDocuments">
                                                                        <a :href="urlPair.allDocuments" class="btn btn-bare icon icon-download" target="_blank">&nbsp;All Downloads</a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <a :href="Object.values(urlPair.documents)[0] as string" v-else-if="Object.keys(urlPair.documents).length == 1" class="btn btn-bare passthrough icon icon-download" aria-label="Download PDF" />
                                                        </template>
                                                        <a @click="gotoSubmission($event, form)" :href="urlPair.review" title="Open web submission" class="btn btn-bare passthrough icon icon-open" target="_blank" aria-label="Open web submission" />
                                                    </div>
                                                </template>
                                            </Promised>
                                        </td>
                                    </tr>
                                </template>

                                <!-- Empty -->
                                <template #empty-message> 0 submissions found </template>
                            </VueDataTable>
                            <div>
                                <div class="d-block-flex float-right">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="!canRetreatPage" @click.prevent="retreatPage"><span aria-hidden="true">&lt;</span> Prev</button>
                                    <template v-if="pageCount == null">
                                        <label for="page2" class="mx-2">Page</label>
                                        <input class="form-control form-control-sm w-auto d-inline" min="1" type="number" id="page2" v-model="pageDisplay" @change="changePage" />
                                    </template>
                                    <template v-else>
                                        <label for="page2" class="mx-2">Page</label>
                                        <select class="form-control form-control-sm w-auto d-inline" id="page2" v-model="tableServerOptions.page" @change="changePage">
                                            <option :selected="tableServerOptions.page == p" :value="p" v-for="p of pageOptions">{{ p + 1 }}</option>
                                        </select>
                                        <span class="mx-2">of {{ pageCount }}</span>
                                    </template>
                                    <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="!canAdvancePage" @click.prevent="advancePage">Next <span aria-hidden="true">&gt;</span></button>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </form>
</template>
<script lang="ts">
import { defineComponent, ref, computed, onActivated, onBeforeMount, onDeactivated, nextTick, watch, inject, reactive } from "vue";
import { useMainStore } from "@/mainStore";
import { throwIfNonSuccessStatus } from "@/lib/fetchHelpers.3";
import { getXsftHeader, getXsrfToken } from "@/lib/getXsrfToken.3";
import { tenantDateTime } from "@/lib/localeDatetime.3";
import getData from "../../lib/getData";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import { Promised } from "@/lib/Promised";
import DatePicker from "@/lib/DatePicker.3.vue";
import SearchSubmission from "./SearchSubmission.3.vue";
import toObjectAsync from "@/lib/toObjectAsync";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { BuiltinExportSchemas } from "@cs/BuiltinExportSchemas";
import { StandardFormStatus } from "@cs/StandardFormStatus";
import { ExportType } from "@cs/ExportType";
import VueDataTable, { Header, ServerOptions } from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import { asyncComputed } from "@vueuse/core";
import { FormListItem as FormListItemCS } from "@cs/FormListItem";
import { FormSettings as FormSettingsCS } from "@cs/FormSettings";
import { FormDefSearch as FormDefSearchCS } from "@cs/FormDefSearch";
import { Status as StatusCS } from "@cs/Status";
import { UserTaskType } from "@cs/UserTaskType";
import { FormListItem as FormListItemTS } from "@cs-ts/form-list-item";
import { FormSettings as FormSettingsTS } from "@cs-ts/form-settings";
import { FormDefSearch as FormDefSearchTS } from "@cs-ts/form-def-search";
import { Status as StatusTS } from "@cs-ts/status";
//@ts-ignore
import { createDateFormatter } from "flatpickr/dist/esm/utils/dates";
import { showModalInjectKey, showModal as showModalType, updatePageInjectKey, updatePage as updatePageType } from "@/AppShell.3.vue.InjectKeys";
import { toggleDropdown } from "@/lib/toggleDropdown.3";
import { createPopper } from "@popperjs/core";
import arrayEquals from "@/lib/arrayEquals";
import { HeaderField } from "@cs/HeaderField";
import { isNullOrWhitespace } from "@/lib/whitespaceMethods";
import { SearchSuccessResults } from "@cs/SearchSuccessResults";
import { SearchPendingResults } from "@cs/SearchPendingResults";
import { SearchFailureResults } from "@cs/SearchFailureResults";
import { FormListItem } from "@cs/FormListItem";

interface NavigatorWithMsSaveOrOpenBlob extends Navigator {
    msSaveOrOpenBlob?: (blob: Blob, filename?: string) => boolean;
}
//interface ExportSchema {
//    [key: string]: {
//        type: ExportType;
//        schema: string;
//    };
//}
interface _FormSettingsTS extends Omit<FormSettingsTS, "statuses"> {
    statuses: (StatusTS & { key: string })[];
}
interface _FormSettingsCS extends Omit<FormSettingsCS, "Statuses"> {
    Statuses: (StatusCS & { Key: string })[];
}
interface FormSearchResult {
    tenant: FormDefCS["Tenant"];
    formId: FormDefCS["Id"];
    viewTypes: FormDefCS["ViewTypes"];
    hasFileUploads: FormDefCS["HasFileUploads"];
    formName: FormDefCS["FormName"];
    formVersion: FormDefCS["FormVersion"];
    formHash: FormDefCS["FormHash"];
    submitDate: FormDefCS["SubmitDate"];
    lastUpdated: FormDefCS["LastUpdated"];
    userName: FormDefCS["UserName"];
    listData: FormDefCS["ListData"];
    adminDisplayLabel: FormDefCS["AdminDisplayLabel"];
    reviewerStatusLabel: FormDefCS["ReviewerStatusLabel"];
    hasIssues: boolean;
}
type FormDefTS = FormListItemTS & _FormSettingsTS & FormDefSearchTS;
type FormDefCS = FormListItemCS & _FormSettingsCS & FormDefSearchCS;

let dropdownShouldOpen: () => boolean = undefined!;
interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO
    settings?: {
        formNameVersion: string;
        startedStartDate: string;
        startedEndDate: string;
        lastUpdatedStartDate: string;
        lastUpdatedEndDate: string;
        submittedStartDate: string;
        submittedEndDate: string;
        testMode: string;
        checkedStatus: string;
        searchFields: string;
    };
}
export default defineComponent({
    components: {
        LoadingPlaceholder,
        LoadingWheel,
        Promised,
        DatePicker,
        "v-select": vSelect,
        VueDataTable,
    },
    forceOpenDropdown() {
        dropdownShouldOpen = () => true;
    },
    props: ["settings"],
    setup(props: Props) {
        const mainStore = useMainStore();
        const showModal = inject(showModalInjectKey)! as showModalType;
        const updatePage = inject(updatePageInjectKey)! as updatePageType;
        const exportSchemas = ref(
            Object.entries(BuiltinExportSchemas.MAP).reduce(
                (a, [k, v]) => {
                    const l = v == "" ? "CSV Export" : `CSV Export (${v})`;
                    a[l] = { type: ExportType.Csv, schema: k };
                    return a;
                },
                {} as { [key: string]: { type: ExportType; schema?: string } },
            ),
        );
        exportSchemas.value["PDF Export"] = { type: ExportType.Pdf };

        const dropdownRef = ref<InstanceType<typeof vSelect>>(null!);
        const searchValueDropdownRef = ref<InstanceType<typeof vSelect>[]>(null!);

        const loaded = ref<boolean>(false);
        const tableLoading = ref<boolean>(false);
        const formNameVersion = ref<Record<string, string> | null>(props.settings?.formNameVersion == null ? null : { value: props.settings.formNameVersion });
        const startedStartDate = ref<string | undefined>(props.settings?.startedStartDate);
        const startedEndDate = ref<string | undefined>(props.settings?.startedEndDate);
        const lastUpdatedStartDate = ref<string | undefined>(props.settings?.lastUpdatedStartDate);
        const lastUpdatedEndDate = ref<string | undefined>(props.settings?.lastUpdatedEndDate);
        const submittedStartDate = ref<string | undefined>(props.settings?.submittedStartDate);
        const submittedEndDate = ref<string | undefined>(props.settings?.submittedEndDate);
        const checkedStatus = ref<Array<string[]>>(props.settings?.checkedStatus != null ? JSON.parse(decodeURIComponent(props.settings.checkedStatus)) : []);
        const testMode = ref<boolean>(props.settings?.testMode == "true");
        const searchFields = reactive<Record<string, string | string[]>>(props.settings?.searchFields != null ? JSON.parse(decodeURIComponent(props.settings.searchFields)) : {});
        const searchFieldsOptions = reactive<Record<string, string[]>>({});
        const searchFieldsOptionsEmpty = reactive<Record<string, string[]>>({});
        const fetchSearchFieldsCompletion = async (fields: Record<string, string>) => {
            const tenantNameVersion = formNameVersion.value!.value.split("`");
            const testModeVal = testMode.value;
            const completeData = {
                FormName: tenantNameVersion[1],
                FormVersion: tenantNameVersion[2],
                TestMode: testModeVal,
                CompletingSearchFields: fields,
            };
            const completeUrl = await mainStore.getUrl("adminSearchFieldCompletion", { tenantCode: tenantNameVersion[0] });
            const completeResponse = await fetch(completeUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...(await getXsftHeader(mainStore)),
                },
                credentials: "same-origin",
                body: JSON.stringify(completeData),
            });
            throwIfNonSuccessStatus(completeResponse);
            const completeJson = (await completeResponse.json()) as Record<string, string[]>;
            return completeJson;
        };
        const fetchSearchFieldCompletion = async (field: string, input: string, loading: (input: boolean) => void) => {
            if ((input == null || /^\s*$/.test(input)) && field in searchFieldsOptionsEmpty) {
                searchFieldsOptions[field] = searchFieldsOptionsEmpty[field];
                return;
            }
            loading(true);
            const completeJson = await fetchSearchFieldsCompletion({ [field]: input });
            searchFieldsOptions[field] = completeJson[field];
            loading(false);
        };

        const updateHistory = async () => {
            await nextTick();
            updatePage(
                {
                    ...props.settings,
                    formNameVersion: formNameVersion.value?.value ?? "",
                    startedStartDate: startedStartDate.value ?? "",
                    startedEndDate: startedEndDate.value ?? "",
                    lastUpdatedStartDate: lastUpdatedStartDate.value ?? "",
                    lastUpdatedEndDate: lastUpdatedEndDate.value ?? "",
                    submittedStartDate: submittedStartDate.value ?? "",
                    submittedEndDate: submittedEndDate.value ?? "",
                    testMode: testMode.value ?? "",
                    checkedStatus: encodeURIComponent(JSON.stringify(checkedStatus.value)),
                    searchFields: encodeURIComponent(JSON.stringify(searchFields)),
                },
                true,
            );
        };

        watch(
            [formNameVersion, startedStartDate, startedEndDate, lastUpdatedStartDate, lastUpdatedEndDate, submittedStartDate, submittedEndDate, testMode, checkedStatus, searchFields],
            () => {
                updateHistory();
            },
            { deep: true },
        );

        onActivated(() => {
            updateHistory();
        });

        const tableServerOptions = ref<ServerOptions>({
            page: 0,
            rowsPerPage: 25,
            sortBy: "lastUpdated",
            sortType: "desc",
        });
        const stockDateFormatter = createDateFormatter({ config: {} });
        const dateTimePickerConfig = {
            enableTime: true,
            allowInput: true,
            altInput: true,
            dateFormat: "m-d-Y h:i:S K",
            altFormat: "m-d-Y h:i:S K",
            disableMobile: true,
            defaultHour: 0,
            formatDate(date: Date, format: string, extraData: unknown) {
                if (date.getTime() == new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()) {
                    format = format.replace("h:i:S K", "").trim();
                }
                return stockDateFormatter(date, format, extraData);
            },
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const searchMetadata = ref({
            pageSize: null as null | number,
            maxResultCount: null as null | number,
            testMode: null as null | boolean,
            status: null as null | string,
            errors: [] as string[],
            pagedResults: [] as FormSearchResult[],
            unpagedResultCount: null as null | number,
            displayColumns: [] as HeaderField[],
        });
        const exportMetadatas = ref<Record<string, unknown>[]>([]);
        const formDefsData = ref<Record<string, Partial<FormDefTS>[]>>({
            true: [],
            false: [],
        });
        const searchField = ref<Record<string, unknown>>({});

        const adminUrl = asyncComputed(() => {
            return mainStore.getUrl("admin");
        });
        const searchUrl = asyncComputed(() => {
            return mainStore.getUrl("adminSearch");
        });
        const xsrfToken = asyncComputed(() => {
            return getXsrfToken(mainStore);
        });
        const availableTestModes = asyncComputed(async () => {
            const userData = await mainStore.userDataPromise;
            const result = [];
            if (userData.CanReview) {
                result.push(false);
            }
            if (userData.CanTestForms) {
                result.push(true);
            }
            return result;
        });
        const canExport = asyncComputed(async () => {
            const userData = await mainStore.userDataPromise;
            return userData.CanSeeAllForms;
        });

        const activeColumns = asyncComputed((): Header[] => [
            {
                text: "",
                value: "issues",
                sortable: false,
                width: 1,
            },
            ...searchMetadata.value.displayColumns.map(item => ({
                text: item.Label != null ? item.Label : "",
                value: item.Value != null ? item.Value : item.Label != null ? item.Label : "",
                sortable: item.Sortable == null ? fieldIsSortable(item.Label!) : item.Sortable,
            })),
            {
                text: "",
                value: "SubmissionUrl",
                sortable: false,
                width: 1,
            },
        ]);

        const pageDisplay = computed({
            get() {
                return tableServerOptions.value.page + 1;
            },
            set(val) {
                tableServerOptions.value.page = val - 1;
            },
        });
        const pageCount = computed(() => {
            if (searchMetadata.value == null || searchMetadata.value.unpagedResultCount == searchMetadata.value.maxResultCount) {
                return null;
            } else {
                return Math.max(1, Math.ceil(searchMetadata.value.unpagedResultCount! / searchMetadata.value.pageSize!));
            }
        });
        const pageOptions = computed(() => {
            const pageCountVal = pageCount.value;
            if (pageCountVal == null) {
                return [];
            }
            const result = [];
            for (let i = 0; i < pageCountVal; i++) {
                result.push(i);
            }
            return result;
        });
        const showTestMode = asyncComputed(async () => {
            return (await mainStore.userDataPromise).ActiveFeatureFlags.includes("TestMode");
        });
        const showSearchEmailExport = asyncComputed(async () => {
            return (await mainStore.userDataPromise).ActiveFeatureFlags.includes("EmailSearchExports");
        });
        const activeFormDefs = computed(() => {
            return formDefsData.value[testMode.value.toString()];
        });
        const selectedForm = computed(() => {
            if (formNameVersion.value == null) {
                return null;
            }
            const [formTenant, formName, formVersion] = formNameVersion.value.value.split("`");
            const formDefs = activeFormDefs.value.filter(i => i.tenant == formTenant && i.formName == formName && i.formVersion == formVersion);
            return formDefs.length > 0 ? formDefs[0] : null;
        });
        watch(
            () => selectedForm.value,
            async (newValue, oldValue) => {
                const fields = visibleSearchFields.value;
                const completions = await fetchSearchFieldsCompletion(
                    fields.reduce<Record<string, string>>((a, i) => {
                        a[i.value] = "";
                        return a;
                    }, {}),
                );
                for (const [k, v] of Object.entries(completions)) {
                    searchFieldsOptions[k] = v;
                    searchFieldsOptionsEmpty[k] = v;
                }
                checkedStatus.value = checkedStatus.value.filter(cS => distinctStatusesByLabel.value.some(s => arrayEquals(s.values, cS)));
                if (oldValue != null && newValue != null && newValue.formName != oldValue.formName) {
                    Object.entries(searchFields).forEach(([k, v]) => {
                        delete searchFields[k];
                    });
                }
            },
        );
        const formStatusesOptions = computed(() => {
            if (selectedForm.value == null) {
                return [];
            }
            const statuses: Record<string, string> = {};
            selectedForm.value.statuses!.forEach(i => {
                statuses[i.key!] = i.value!;
            });
            return Object.keys(statuses).map(k => ({
                value: k,
                label: statuses[k],
            }));
        });
        const formNameOptions = computed(() => {
            const result = activeFormDefs.value.map(i => ({
                value: i.tenant + "`" + i.formName + "`" + i.formVersion,
                label: i.formLabel || "",
            }));
            result.sort((a, b) => (a.label + "").localeCompare(b.label));
            return result;
        });
        watch(
            () => formNameOptions.value,
            (newVal: { value: string; label: string }[]) => {
                if (formNameVersion.value != null && newVal.length != 0) {
                    //@ts-ignore
                    formNameVersion.value = newVal.find(i => i.value == formNameVersion.value.value);
                }
            },
        );
        const distinctStatusesByLabel = computed(() => {
            var result = Array.from(new Set(formStatusesOptions.value.map(s => s.label))).map(label => {
                const values = formStatusesOptions.value.filter(s => s.label == label).map(s => s.value);
                return {
                    label,
                    values,
                    isEnabledByDefault: values.every(i => !StandardFormStatus.ForcedStatuses.includes(i)),
                };
            });
            return result.filter(x => !x.label?.includes("(submitting)"));
        });
        const visibleSearchFields = computed(() => {
            if (selectedForm.value == null) {
                return [];
            }
            return selectedForm.value.searchFields!.map(i => ({ value: i as string, label: i }));
        });
        const canAdvancePage = computed(() => {
            return searchMetadata.value != null && (searchMetadata.value.maxResultCount == searchMetadata.value.unpagedResultCount ? searchMetadata.value.pagedResults.length == searchMetadata.value.pageSize : (tableServerOptions.value.page + 1) * searchMetadata.value.pageSize! < searchMetadata.value.unpagedResultCount!);
        });
        const canRetreatPage = computed(() => {
            return searchMetadata.value != null && tableServerOptions.value.page > 0;
        });
        const showSubmitFilterWarning = computed(() => {
            return checkedStatus.value.some(i => i.includes(StandardFormStatus.InProgress)) && ((submittedStartDate.value != null && /\S/.test(submittedStartDate.value)) || (submittedEndDate.value != null && /\S/.test(submittedEndDate.value)));
        });

        const advancePage = () => {
            if (canAdvancePage.value) {
                tableServerOptions.value.page++;
                runSearch("Search");
            }
        };
        const retreatPage = () => {
            if (canRetreatPage.value) {
                tableServerOptions.value.page--;
                runSearch("Search");
            }
        };
        const changePage = () => {
            runSearch("Search");
        };
        const gotoSubmission = (event: Event, form: FormSearchResult) => {
            event.preventDefault();
            const a = selectedForm.value;
            const b = { formName: a?.formName, formVersion: a?.formVersion, tenant: a?.tenant };
            showModal(SearchSubmission, { form: form || b, triggerElement: event.target });
        };
        const getColumnValue = (col: HeaderField, form: FormSearchResult) => {
            if (col.IsSystemField) {
                switch (col.Value) {
                    case "lastUpdated":
                        return tenantDateTime(form.lastUpdated);
                    case "submitDate":
                        return tenantDateTime(form.submitDate);
                    case "User":
                        return form.userName;
                    case "Label":
                        return form.adminDisplayLabel;
                    case "Status":
                        return form.reviewerStatusLabel;
                }
            } else if (form.listData != null) {
                return (form.listData[col.Label!] || []).join("; ");
            }
            return "";
        };
        const formUrlsPromise = async (form: FormSearchResult) => {
            const result = {
                attachments: null as string | null,
                allDocuments: null as string | null,
                documents: await toObjectAsync(form.viewTypes ?? [], async (t: string) => await mainStore.getUrl("adminSearchReviewDocument", { tenantCode: form.tenant, formId: form.formId, document: t })),
                review: await mainStore.getUrl("adminSearchReview", { areaCode: form.tenant, formId: form.formId, pageNumber: 1 }),
            };
            if (form.hasFileUploads) {
                result.attachments = await mainStore.getUrl("adminSearchReviewAttachments", { tenantCode: form.tenant, formId: form.formId });
            }
            if (form.hasFileUploads || (form.viewTypes?.length ?? 0) > 1) {
                result.allDocuments = await mainStore.getUrl("adminSearchReviewAllDocuments", { tenantCode: form.tenant, formId: form.formId });
            }
            return result;
        };
        const removeExport = (metadata: Record<string, unknown>) => {
            exportMetadatas.value.splice(exportMetadatas.value.indexOf(metadata), 1);
        };
        const startExport = async (exportFormat: number, exportSchema: string | undefined) => {
            runSearch("Export", exportFormat, exportSchema);
        };
        const fieldIsSortable = (key: string) => {
            // @ts-ignore
            return visibleSearchFields.value.some(i => i.value === key);
        };
        const startSearch = async () => {
            tableServerOptions.value.page = 0;
            tableServerOptions.value.sortBy = "lastUpdated";
            tableServerOptions.value.sortType = "desc";
            searchMetadata.value = { status: [], errors: [] } as unknown as (typeof searchMetadata)["value"];
            runSearch("Search");
        };
        const runSearch = async (searchAction: string, exportFormat?: number, exportSchema?: string) => {
            tableLoading.value = true;
            const isSearch = searchAction == "Search";
            const metadata = isSearch ? searchMetadata.value : reactive({ status: [], errors: [] } as unknown as (typeof searchMetadata)["value"]);
            if (!isSearch) {
                exportMetadatas.value.push(metadata);
            }
            metadata.status = "in-progress";
            const tenantNameVersion = formNameVersion.value!.value.split("`");
            const searchUrl = await mainStore.getUrl("adminSearchV2", { tenantCode: tenantNameVersion[0] });
            const testModeVal = testMode.value;
            let searchStatuses = checkedStatus.value.flat();
            let searchStatuslabels = formStatusesOptions.value.filter(x => searchStatuses.includes(x.value)).map(x => x.label);
            searchStatuslabels.push(...searchStatuslabels.map(x => x + " (submitting)"));
            const combinedStatuses = formStatusesOptions.value.filter(x => searchStatuslabels.includes(x.label)).map(x => x.value);
            let searchFieldsV: Record<string, string[]> = {};
            Object.entries(searchFields || {}).forEach(([k, v]) => {
                searchFieldsV[k] = Array.isArray(v) ? v : [v];
            });
            //if (searchStatuses.length == 0) {
            //    searchStatuses = distinctStatusesByLabel.value
            //        .filter(i => i.isEnabledByDefault)
            //        .map(i => i.values)
            //        .flat();
            //}
            const searchData = {
                FormNameVersion: tenantNameVersion[1] + "`" + tenantNameVersion[2],
                StartedStartDate: startedStartDate.value,
                StartedEndDate: startedEndDate.value,
                SubmittedStartDate: submittedStartDate.value,
                SubmittedEndDate: submittedEndDate.value,
                LastUpdatedStartDate: lastUpdatedStartDate.value,
                LastUpdatedEndDate: lastUpdatedEndDate.value,
                SearchValue: searchFieldsV,
                SearchStatuses: combinedStatuses,
                TestMode: testModeVal,
                Action: searchAction,
                ExportFormat: exportFormat,
                ExportSchema: exportSchema,
                Page: tableServerOptions.value.page,
                Sort: tableServerOptions.value.sortBy,
                SortDesc: tableServerOptions.value.sortType == "desc",
                IncludeTotal: metadata.unpagedResultCount == null,
            };
            try {
                const searchResponse = await fetch(searchUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        ...(await getXsftHeader(mainStore)),
                    },
                    credentials: "same-origin",
                    body: JSON.stringify(searchData),
                });
                throwIfNonSuccessStatus(searchResponse);
                if (isSearch) {
                    const searchJson = (await searchResponse.json()) as SearchSuccessResults | SearchFailureResults;
                    if (searchJson.Success) {
                        metadata.status = "ok";
                        metadata.testMode = testModeVal;
                        if (searchData.IncludeTotal) {
                            metadata.unpagedResultCount = searchJson.UnpagedResultCount;
                            metadata.maxResultCount = searchJson.MaxResultCount ?? null;
                        }
                        metadata.pageSize = searchJson.PageSize;
                        metadata.pagedResults = searchJson.PagedResults.map((r: FormListItem, _i: number) => {
                            const item: FormSearchResult = {
                                tenant: r.Tenant,
                                formId: r.Id,
                                viewTypes: r.ViewTypes,
                                hasFileUploads: r.HasFileUploads,
                                formName: r.FormName,
                                formVersion: r.FormVersion,
                                formHash: r.FormHash,
                                submitDate: r.SubmitDate,
                                lastUpdated: r.LastUpdated,
                                userName: r.UserName,
                                listData: r.ListData,
                                adminDisplayLabel: r.AdminDisplayLabel,
                                reviewerStatusLabel: r.ReviewerStatusLabel,
                                hasIssues: r.UserTasks.some(i => i.Type == UserTaskType.Issue),
                            };
                            return item;
                        });
                        metadata.displayColumns = searchJson.DisplayColumns;
                    } else if (searchJson.Success === false) {
                        metadata.status = "fail";
                        metadata.errors = Array.prototype.concat.apply([], Object.values(searchJson.ErrorsDetailed)) || ["Unknown error occurred"];
                    } else {
                        metadata.status = "fail";
                        metadata.errors = ["Unknown error occurred"];
                        throw new Error("Assertion failed");
                    }
                } else {
                    const handleFileResponse = async (fileResponse: Response) => {
                        let filename = "Export.zip";
                        const disposition = fileResponse.headers.get("content-disposition");
                        const blob = await fileResponse.blob();
                        // https://stackoverflow.com/a/40940790
                        if (disposition && disposition.indexOf("attachment") !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, "");
                            }
                        }
                        const windowNavigator: NavigatorWithMsSaveOrOpenBlob = window.navigator;
                        // https://stackoverflow.com/a/48968694
                        if (windowNavigator.msSaveOrOpenBlob) {
                            windowNavigator.msSaveOrOpenBlob(blob, filename);
                        } else {
                            const a = document.createElement("a");
                            document.body.appendChild(a);
                            const url = window.URL.createObjectURL(blob);
                            a.href = url;
                            a.download = filename;
                            a.click();
                            setTimeout(() => {
                                window.URL.revokeObjectURL(url);
                                document.body.removeChild(a);
                            }, 0);
                        }
                        metadata.status = "ok";
                        metadata.errors = [];
                    };
                    if (searchResponse.headers.get("content-type")!.includes("application/json")) {
                        const searchJson = (await searchResponse.json()) as SearchPendingResults | SearchFailureResults;
                        if (searchJson.Success !== false) {
                            const checkUrl = await mainStore.getUrl("adminSearchExportReady", { token: searchJson.Token });
                            const delay = [1, 1, 1, 2, 3, 5, 8, 13, 21, 34];
                            const checkForComplete = () => {
                                setTimeout(
                                    async () => {
                                        try {
                                            const checkResponse = await fetch(checkUrl, {
                                                method: "GET",
                                                credentials: "same-origin",
                                            });
                                            throwIfNonSuccessStatus(checkResponse);
                                            const checkJson = (await checkResponse.json()) as SearchSuccessResults | SearchFailureResults;
                                            if (checkJson) {
                                                const fetchUrl = await mainStore.getUrl("adminSearchExportFetch", { token: searchJson.Token });
                                                const fetchResponse = await fetch(fetchUrl, {
                                                    method: "GET",
                                                    credentials: "same-origin",
                                                });
                                                throwIfNonSuccessStatus(fetchResponse);
                                                handleFileResponse(fetchResponse);
                                            } else {
                                                checkForComplete();
                                            }
                                        } catch {
                                            metadata.status = "fail";
                                            metadata.errors = ["Unknown error occurred"];
                                        }
                                    },
                                    (delay.shift() || 40) * 1000,
                                );
                            };
                            checkForComplete();
                        } else {
                            metadata.status = "fail";
                            metadata.errors = Array.prototype.concat.apply([], Object.values(searchJson.ErrorsDetailed)) || ["Unknown error occurred"];
                        }
                    } else {
                        handleFileResponse(searchResponse);
                    }
                }
            } catch (e) {
                metadata.status = "fail";
                metadata.errors = ["Unknown error occurred"];
                throw e;
            }
            tableLoading.value = false;
        };
        const updateSelectedValues = (event: Event, values: string[]) => {
            if ((<HTMLInputElement>event.target).checked) {
                checkedStatus.value.push(values);
            } else {
                const index = checkedStatus.value.findIndex(arr => arr.toString() === values.toString());
                if (index !== -1) {
                    checkedStatus.value.splice(index, 1);
                }
            }
        };
        const toggleAllStatuses = () => {
            if (checkedStatus.value.length == 0) {
                checkedStatus.value = distinctStatusesByLabel.value.map(i => i.values);
            } else {
                checkedStatus.value = [];
            }
        };
        const openDropdown = async (vSelectRef: typeof vSelect, label: string) => {
            // Set search input's own aria label and required data if no selected option
            vSelectRef.searchEl?.closest("[role='combobox']").setAttribute("aria-label", label);
            await nextTick();
            document.querySelectorAll(`#vs${vSelectRef.uid}__listbox`).forEach(elem => {
                elem.setAttribute("aria-label", label);
            });
        };
        const calculatePositionWithPopper = (dropdownList: HTMLElement, component: typeof vSelect, { width }: { width: string }) => {
            dropdownList.style.width = width;
            dropdownList.classList.add("custom-vSelect");
            const popper = createPopper(component.searchEl.closest("[role='combobox']"), dropdownList, {
                placement: "bottom-start",
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [0, -1],
                        },
                    },
                ],
            });
            return () => popper.destroy();
        };

        watch(
            () => tableServerOptions.value,
            () => {
                runSearch("Search");
            },
        );

        onBeforeMount(async () => {
            loaded.value = false;
            await mainStore.userDataPromise;
            await nextTick(); // for availableTestModes to load
            const propTestMode = isNullOrWhitespace(props.settings?.testMode) ? null : props.settings!.testMode == "true";
            testMode.value = availableTestModes.value.find(i => i == propTestMode) ?? availableTestModes.value[0];
            const formImportData = await getData(mainStore, "AdminSearch", () => mainStore.getUrl("adminSearchData", { testMode: testMode.value }));
            const mapper = (ef: FormDefCS) => ({
                tenant: ef.Tenant,
                formName: ef.FormName,
                formVersion: ef.FormVersion,
                formLabel: ef.FormLabel,
                statuses: ef.Statuses.map(i => ({
                    key: i.Key,
                    value: i.Value,
                })),
                searchFields: ef.SearchFields,
            });
            formDefsData.value["false"] = formImportData.FormDefSearches == null ? null : formImportData.FormDefSearches.map(mapper);
            formDefsData.value["true"] = formImportData.FormDefTestSearches == null ? null : formImportData.FormDefTestSearches.map(mapper);
            //formNameVersion.value = formImportData.FormNameSearch;
            //startDate.value = formImportData.StartDate;
            //endDate.value = formImportData.EndDate;
            // checkedStatus.value = formImportData.SearchStatuses || [];
            // Object.keys(formImportData.SearchValue || {}).forEach(k => {
            //     searchField.value[k] = formImportData.SearchValue[k];
            // });
            if (formNameVersion.value == null) {
                const momentPromise = import(/* webpackChunkName: "Moment", webpackPrefetch: true */ "moment");
                const moment = (await momentPromise).default;
                const now = mainStore.now();
                submittedStartDate.value = moment(now).add(-7, "days").startOf("day").format("MM-DD-YYYY");
                submittedEndDate.value = moment(now).add(1, "days").startOf("day").format("MM-DD-YYYY");
            }
            loaded.value = true;
        });
        onActivated(() => {
            const body = document.getElementsByTagName("body")[0];
            body.classList.add("content-scroll");
            body.classList.add("no-footer");
        });
        onDeactivated(() => {
            const body = document.getElementsByTagName("body")[0];
            body.classList.remove("content-scroll");
            body.classList.remove("no-footer");
        });

        return {
            // Ref
            dropdownRef,
            searchValueDropdownRef,

            // States
            exportSchemas,
            loaded,
            formNameVersion,
            startedStartDate,
            startedEndDate,
            dateTimePickerConfig,

            lastUpdatedStartDate,
            lastUpdatedEndDate,
            submittedStartDate,
            submittedEndDate,
            checkedStatus,
            testMode,
            searchFields,
            searchFieldsOptions,
            searchMetadata,
            exportMetadatas,
            formDefsData,
            searchField,
            tableLoading,
            tableServerOptions,

            // Async Computed
            adminUrl,
            searchUrl,
            xsrfToken,
            availableTestModes,
            canExport,

            // Computed
            activeColumns,
            pageDisplay,
            pageCount,
            pageOptions,
            showTestMode,
            showSearchEmailExport,
            activeFormDefs,
            selectedForm,
            formStatusesOptions,
            formNameOptions,
            distinctStatusesByLabel,
            visibleSearchFields,
            canAdvancePage,
            canRetreatPage,
            showSubmitFilterWarning,

            // Methods
            advancePage,
            retreatPage,
            changePage,
            gotoSubmission,
            getColumnValue,
            formUrlsPromise,
            removeExport,
            startExport,
            fieldIsSortable,
            startSearch,
            runSearch,
            updateSelectedValues,
            toggleAllStatuses,
            openDropdown,
            calculatePositionWithPopper,
            fetchSearchFieldCompletion,

            //eslint-disable-next-line @typescript-eslint/no-explicit-any
            asForm: (a: any) => a as FormSearchResult[],

            // Mixin
            tenantDateTime,

            dropdownShouldOpen,
            toggleDropdown,
            arrayEquals,
        };
    },
});
</script>
